<div class="teams__container p-5">
  <div class="d-flex align-items-center justify-content-between">
    <a mat-raised-button class="uppercase" (click)="openNewTeamDialog()" color="primary">
      Agregar Equipo</a>
  </div>
  <table mat-table [dataSource]="tournamentTeamsList">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let el">{{ el.team_name }}</td>
    </ng-container>
    <ng-container matColumnDef="administrator">
      <th mat-header-cell *matHeaderCellDef>Capitán</th>
      <td mat-cell *matCellDef="let el">{{ el.team_captain_name }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>Tel.</th>
      <td mat-cell *matCellDef="let el">{{ el.team_captain_phone }}</td>
    </ng-container>
    <ng-container matColumnDef="teamQuantity">
      <th mat-header-cell *matHeaderCellDef>Cant. Jugadores</th>
      <td mat-cell *matCellDef="let el">{{ el.team_player_quantity }}</td>
    </ng-container>
    <ng-container matColumnDef="paymentStatus">
      <th mat-header-cell *matHeaderCellDef>Pago Inscripción</th>
      <td mat-cell *matCellDef="let el">
        <div class="d-flex justify-content-between align-items-center">
          <span class="mr-5">
            {{ getPaymentStatus(el.status) }}
          </span>
          <button *ngIf="el.status !== 1" (click)="confirmTeamForTournament(el)" mat-raised-button color="primary">Confirmar</button>

        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [length]="totalRecords" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
  </mat-paginator>
</div>